import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { first } from 'rxjs';
import { AutomationService } from 'src/app/services/automation.service';
import { ControlService } from 'src/app/services/control.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-advanced',
  templateUrl: './advanced.component.html',
  styleUrls: ['./advanced.component.css'],
  standalone: true,
  imports: [TranslateModule, FormsModule]
})
export class AdvancedComponent {

  @Input() control: ControlService;
  @Input() device: any;

  //Modals
  modalRef!: MatDialogRef<any>;

  constructor(
    private automationService: AutomationService,
    private dialog: MatDialog,
  ) {
  }

  press(key) {
    this.control.keyPress(key)
  }

  refresh() {
    let url = this.device.providerUrl;
    this.automationService.getPackageName(url, this.device.serial).pipe(first()).subscribe((res: any) => {

    });
  }

  reboot() {
    this.cancelRequest();
    let config = {
      rebootEnabled: true
    }

    if (config.rebootEnabled) {
      this.control.reboot(this.device).then((result) => {
        console.error(result)
      })
    }
  }

  // Modals
  rebootDeviceTemplate(template: TemplateRef<any>) {
    this.modalRef = this.dialog.open(template);
  }

  cancelRequest() {
    this.modalRef.close();
  }

  key(key: any) {

    this.control.keyDown(key)
    this.control.keyUp(key)
  }
}
